import type { FaireProductEntity } from "../../entity_types/product";

export const p_7ujb8p9eey: FaireProductEntity = {
  token: "p_7ujb8p9eey",
  type: "product",
  name: "50 Ethics Ideas You Really Need to Know",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/83545bd3bb4fb902eee3059e6e8425b560291a5e4cd989c423f37a71b1fe4600.jpeg",
  galleryImageUrls: [],
  priceDollars: 9.5,
  description: "Discover the 50 ethics conversations that have shaped our lives and changed the course of history.\n\nQuestions of ethics - about how we should act, our responsibilities to one another, the difference between right and wrong - have long been debated by philosophers the world over and form the foundations of government, culture and religion. Here, in 50 concise chapters, Ben Dupré explains the fundamentals of this discipline and how it is relevant to our lives every day.\n\nCovering essential ethical concepts, including relativism, the golden rule and utilitarianism, as well as high-profile issues such as terrorism, censorship and the death penalty, 50 Ethics Ideas You Really Need to Know will lead you through the moral maze - and rattle your conscience in the process.",
  tags: [],
  msrpDollars: 18.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:06:22.282Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
